import React from 'react';
import { Link } from 'react-router-dom';
import 'react-dropdown/style.css';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import { getAllSettlementListOfUserById } from '../../../Actions/actions';
import PlanStub from '../../common/planStub';
import BigMoney from '../../common/bigMoney';
import 'react-phone-number-input/style.css';
import 'react-responsive-ui/style.css';

class ViewSettlement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: localStorage.getItem('userId'),
      id: this.props.match.params.settlementId,
      settlementUserIdAffiliateData1: {},
      settlementUserIdAffiliateData2: [],
      UserName: '',
      openComponents: false,
      openInfoDialog: false,
    };
    this.openViewTimeLineModal = this.openViewTimeLineModal.bind(this);
  }

  /**
   * Get User Info
   */
  componentDidMount() {
    this.setState({ id: this.props.match.params.settlementId });
    this.props.getAllSettlementListOfUserById(this.state);
    Auth.currentUserInfo()
      .then((res) => {
        const Fname = res.attributes['custom:first_name'];
        const Lname = res.attributes['custom:last_name'];
        const name = `${Fname} ${Lname}`;

        this.setState({ UserName: name });
      })
      .catch((error) => error);
  }

  openViewTimeLineModal(e) {
    e.preventDefault();
    this.setState({
      openComponents: true,
    });
  }

  componentDidUpdate() {
    const { settlementUserIdAffiliateData } = this.props.data;
    const { settlementUserIdAffiliateData1 } = this.state;
    if (settlementUserIdAffiliateData1 !== settlementUserIdAffiliateData) {
      this.setState({
        settlementUserIdAffiliateData1: settlementUserIdAffiliateData,
      });
    }
  }

  /**
   * Open dialog
   */
  handleClickOpen = () => {
    this.setState({
      openInfoDialog: true,
    });
  };

  /**
   * Close delete dialog
   */
  handleClose = () => {
    this.setState({ openInfoDialog: false });
  };

  render() {
    const { settlementUserIdAffiliateData1, id } = this.state;
    return (
      <span>
        <div className='container'>
          <div className='main-content bg-grey'>
            <div className='section-content dashboard'>
              <div className='row'>
                <div className='dashboard-tabs'>
                  <div className='row '>
                    <div className=''>
                      <div className='section-content partner-dashboard partner-referral parnter-settlement-detail-view'>
                        <div className='row'>
                          <div className='col s12 referral-hdr'>
                            <h4 className='col s12 m9'>Settlement Details</h4>
                          </div>

                          <div
                            id='AllSettlemnet'
                            className='referral-data col s12 tab-data active'
                          >
                            <div className='col s12'>
                              <div className='settlement-grid'>
                                <div className='settlement-referealgrid-inner'>
                                  <div className='grid-outer div-full'>
                                    <div className='settlement-newtop'>
                                      <ul>
                                        <PlanStub
                                          name={
                                            settlementUserIdAffiliateData1.shortName
                                          }
                                          price={
                                            settlementUserIdAffiliateData1.totalMoneyAvailable
                                          }
                                          tbdAmount={
                                            settlementUserIdAffiliateData1.tbdAmount
                                          }
                                          item={settlementUserIdAffiliateData1}
                                          claimPeriodEndDate={
                                            settlementUserIdAffiliateData1.settlementImportantDateDto !==
                                            undefined
                                              ? settlementUserIdAffiliateData1
                                                  .settlementImportantDateDto
                                                  .claimPeriodEnd
                                              : ''
                                          }
                                          cat='partner'
                                          type='settlement'
                                          isShow={false}
                                        />
                                        <div className='col s12 m12'>
                                          <div className='col s12 right-align apply-btn'>
                                            <Link
                                              className='waves-light btn btn-blue save-changes'
                                              to={`/enrollmentpage/${id}`}
                                            >
                                              View Enrollments
                                            </Link>
                                          </div>
                                        </div>
                                        <div className='col s12'>
                                          <div className='col s6'>
                                            <h4>
                                              <b>Total Funds:</b>{' '}
                                              {settlementUserIdAffiliateData1 !==
                                              undefined ? (
                                                <BigMoney
                                                  value={
                                                    settlementUserIdAffiliateData1.totalMoneyAvailable
                                                  }
                                                />
                                              ) : (
                                                ''
                                              )}
                                            </h4>
                                          </div>
                                          <div className='col s6'>
                                            <h4 className='commision-right'>
                                              <b>Commission:</b>{' '}
                                              {settlementUserIdAffiliateData1 !==
                                              undefined ? (
                                                <BigMoney
                                                  value={
                                                    settlementUserIdAffiliateData1.fundCommission
                                                  }
                                                />
                                              ) : (
                                                ''
                                              )}
                                            </h4>
                                          </div>
                                        </div>
                                      </ul>
                                    </div>
                                    <div className='border-bottomsettlement' />
                                  </div>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

ViewSettlement.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  data: state.data,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getAllSettlementListOfUserById }, dispatch);

export default withAlert(
  connect(mapStateToProps, mapDispatchToProps)(ViewSettlement)
);
